package fr.arcplex.network.http

import io.ktor.client.statement.*
import io.ktor.http.*

/**
 * Provides an extension to evaluation whether the response is a 1xx code
 */
val HttpResponse.isInformational: Boolean get() = this.status.value in 100..199

/**
 * Provides an extension to evaluation whether the response is a 3xx code
 */
val HttpResponse.isRedirect: Boolean get() = this.status.value in 300..399

/**
 * Provides an extension to evaluation whether the response is a 4xx code
 */
val HttpResponse.isClientError: Boolean get() = this.status.value in 400..499

/**
 * Provides an extension to evaluation whether the response is a 5xx (Standard) through 999 (non-standard) code
 */
val HttpResponse.isServerError: Boolean get() = this.status.value in 500..999

/**
 * Converts Ktor Headers to MultiValueMap (Map<String, List<String>>)
 */
val HttpResponse.headersMap: Map<String, List<String>> get() = this.headers.entries().associate { it.key to it.value }